const showMessageQueue = (() => {
  let queue = [];
  let isShowing = false;

  const processQueue = (api) => {
    if (queue.length === 0) {
      isShowing = false;
      return;
    }

    isShowing = true;
    const { type, content } = queue.shift();
    api.open({ type, content });

    setTimeout(() => {
      api.destroy();
      processQueue(api);
    }, 2000);
  };

  return (api, type, content) => {
    queue.push({ type, content });
    if (!isShowing) processQueue(api);
  };
})();

export default showMessageQueue;
